// Mapeia as chaves de statusOf (equipment.js) para as chaves i18n de common:device_status.
export const statusKeyToI18n = {
  op: 'operating',
  stop: 'stopped',
  notelem: 'no_telemetry',
  down: 'no_comms',
  // Paragem aberta, um estado por balde GMG.
  stop_delay: 'stop_delay',
  stop_nonprod: 'stop_nonprod',
  stop_standby: 'stop_standby',
  stop_breakdown: 'stop_breakdown',
}

export function statusLabel(t, key) {
  const i18nKey = statusKeyToI18n[key]
  return i18nKey ? t('common:device_status.' + i18nKey) : key
}

// statusText: o rótulo do estado com o MOTIVO da paragem quando há um. O nome do
// balde é traduzido; o motivo vem do cadastro da mina e passa intacto, como todo
// dado de cliente. Sem isto o cartão dizia só "Parada" e o despachante tinha de
// abrir o equipamento para saber se era almoço ou pneu furado.
export function statusText(t, st) {
  const base = statusLabel(t, st.key)
  return st.reason ? `${base}: ${st.reason}` : base
}

// O backend manda o estado do ciclo e o rótulo do passo já resolvidos, em português:
// são o vocabulário fixo do cycleLabelFor mais as grades canônicas de passos
// (vmc-test/PRODUCTION-STEPS.md). Passo renomeado no cadastro da Frota é dado do
// cliente e passa direto, sem tradução.
const CYCLE_STATE_KEYS = {
  'Checklist': 'checklist',
  'Checklist OK': 'checklist_ok',
  'Checklist reprovado': 'checklist_failed',
  'Registros': 'registry',
  'Produção iniciada': 'production_started',
  'Em ciclo': 'in_cycle',
  'Ciclo concluído': 'cycle_done',
  'Em produção': 'in_production',
  'Paragem': 'stop',
  'Desligado': 'off',
  'Aguardando': 'waiting',
  'Perfurando': 'drilling',
  'Classificando furo': 'hole_classify',
  'Furo concluído': 'hole_done',
  'Furo descartado': 'hole_aborted',
  'Em viagem (vazio)': 'travel_empty',
  'Espera carga': 'wait_load',
  'Em carga': 'loading',
  'Em viagem (carregado)': 'travel_loaded',
  'Aguarda descarga': 'wait_unload',
  'Descarga': 'unloading',
  'Carga': 'load',
  'Viagem': 'travel',
  'Limpeza': 'cleaning',
  'Rock break': 'rock_break',
  'Ajuste de talude': 'slope_adjust',
  'Crusher maintenance': 'crusher_maint',
  'Drainage works': 'drainage',
  'Furo': 'hole',
  'Posicionamento': 'positioning',
  'Entre furos': 'between_holes',
}

export function cycleStateLabel(t, state) {
  if (!state) return ''
  const key = CYCLE_STATE_KEYS[state]
  return key ? t(`common:cycle_state.${key}`) : state
}

// stepLabel: o passo do ciclo traduzido pelo CÓDIGO quando é um código da grade
// canônica; passo renomeado no cadastro (código desconhecido) cai no rótulo, que é dado
// do cliente ou o vocabulário em português do backend.
export function stepLabel(t, i18n, step) {
  const code = step?.code
  if (code && /^[a-z][a-z0-9_]*$/.test(code) && i18n.exists(`common:cycle_state.${code}`)) {
    return t(`common:cycle_state.${code}`)
  }
  return cycleStateLabel(t, step?.label || code || '')
}
